import cssVars from 'css-vars-ponyfill';

cssVars({
	variables: {
		'primary': '78, 76, 77',
		'primary-dark': '34, 31, 32',
		'accent': '233, 205, 124',
		'accent-plus': '0, 0, 0',
	},
});